module.exports = __webpack_public_path__ + "img/52_47.f0e64b7e.png";